import { createContext, useContext } from 'react';

export const AnimationGraphContext = createContext(null);

export function useAnimationGraphActions() {
  const v = useContext(AnimationGraphContext);
  if (!v) throw new Error('useAnimationGraphActions outside AnimationGraphContext');
  return v;
}
